import { render, staticRenderFns } from "./PendingOrdersSheet.vue?vue&type=template&id=3aca3563&scoped=true"
import script from "./PendingOrdersSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingOrdersSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PendingOrdersSheet.vue?vue&type=style&index=0&id=3aca3563&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca3563",
  null
  
)

export default component.exports